import React, { useEffect } from "react";
import PropTypes from "prop-types";
import TitlePages from "../../layout/TitlePages";
import Breadcrumbs from "../../layout/Breadcrumbs";
import "./EleccionesEscolares.css";

const TextParagraph = ({ children, strongText, className = "" }) => (
  <p className={className}>
    {children}
    {strongText && <span className="text-strong">{strongText}</span>}
  </p>
);

export const EleccionesEscolares = () => {
  useEffect(() => {
    document.title = `Elecciones Escolares`;
  }, []);

  return (
    <>
      <Breadcrumbs
        path={[{ label: "Cultura Cívica" }, { label: "Elecciones Escolares" }]}
      />

      <div className="margin-bottom-2">
        <TitlePages title="Cultura Cívica" subTitle="Elecciones Escolares" />

        <div className="ContenidoCivica">
          <a
            className="civica-pill-button"
            href="https://itetlax.org.mx/assets/pdf/ccivica/1.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              className="civica-pill-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="12" y1="18" x2="12" y2="12" />
              <line x1="9" y1="15" x2="15" y2="15" />
            </svg>
            <span>Manual de Elecciones Escolares</span>
            <span className="visually-hidden"> (se abre en una nueva pestaña)</span>
          </a>

          <TextParagraph>
        El Instituto Tlaxcalteca de
        Elecciones (ITE) invita a las
        instituciones educativas de nivel
        básico y medio superior a
        participar en una actividad
        esencial para promover valores
        cívicos y la cultura democrática.
        Este ejercicio involucra a las y los
        directivos, cuerpos docentes y
        comunidad estudiantil en el
        proceso de la Elección Escolar,
        con el objetivo de formar
        ciudadanos participativos y
        comprometidos con su
        comunidad.
        </TextParagraph>
        <TextParagraph>
        A través de este proceso
        democrático, el alumnado elige
        a sus representaciones de la
        sociedad de alumnas y alumnos,
        consejos, comités estudiantiles u
        análogos, con el
        acompañamiento del personal
        del ITE. 
        </TextParagraph>
        <TextParagraph>
        La experiencia acumulada,
        formalizada en el Manual de
        Elecciones Escolares del ITE
        (Acuerdo ITE-CG 28/2020),
        sistematiza la ejecución de estos
        ejercicios cívicos.
                </TextParagraph>
        <TextParagraph>
        Es importante destacar que, a
        partir de la pandemia por
        COVID-19 y la implementación
        de la estrategia “Aprende en
        Casa 2”, el Manual se adaptó
        exitosamente a la modalidad
        virtual, aprovechando las
        tecnologías de la información y
        las herramientas digitales. De
        esta manera, se garantiza la
        continuidad del desarrollo de la
        ciudadanía, ofreciendo a las instituciones educativas la
        flexibilidad de realizar elecciones
        escolares de forma virtual o
        presencial, según sus
        necesidades
        </TextParagraph>
        <TextParagraph>
        El Manual de Elecciones
        Escolares, incluye un capítulo
        detallado sobre la organización
        de elecciones tanto en
        modalidad virtual como
        presencial.
        </TextParagraph>
        <TextParagraph>
        Invitamos a todas las instituciones
        educativas a consultarlo, a
        solicitar el acompañamiento de
        este Instituto para llevar a cabo el
        ejercicio de Elecciones Escolares
        y a promover la participación
        activa de su comunidad
        estudiantil en la vida
        democrática escolar.
        </TextParagraph>

          <div className="civica-contacto">
            <h3>Datos de contacto:</h3>
            <p>
              Dirección de Organización Electoral, Capacitación y Educación Cívica
              <br /> Ex – Fábrica San Manuel S/N, Barrio Nuevo, C.P. 90640, San
              Miguel Contla, Santa Cruz Tlaxcala, Tlaxcala.
              <br />
              Correo electrónico:{" "}
              <a
                href="mailto:organizacionelectoral@itetlax.org.mx"
                className="civica-email-link"
              >
                organizacionelectoral@itetlax.org.mx
              </a>
              <br />
              Tel. 246 46 50340 ext. 105 y 106
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default EleccionesEscolares;

TextParagraph.propTypes = {
  children: PropTypes.node,
  strongText: PropTypes.string,
  className: PropTypes.string,
};
